import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(3.000000, 3.000000)">
          <mask id="applications-mask" fill="white">
            <path d="M5.75,0.5 L5.75,1.25 L12.25,1.25 L12.25,0.5 L13.75,0.5 L13.75,1.25 L16,1.25 C16.9664983,1.25 17.75,2.03350169 17.75,3 L17.75,15 C17.75,15.9664983 16.9664983,16.75 16,16.75 L2,16.75 C1.03350169,16.75 0.25,15.9664983 0.25,15 L0.25,3 C0.25,2.03350169 1.03350169,1.25 2,1.25 L4.25,1.25 L4.25,0.5 L5.75,0.5 Z M16.25,5.75 L1.75,5.75 L1.75,15 C1.75,15.1380712 1.86192881,15.25 2,15.25 L16,15.25 C16.1380712,15.25 16.25,15.1380712 16.25,15 L16.25,5.75 Z M14,11.75 L14,13.25 L12,13.25 L12,11.75 L14,11.75 Z M10,11.75 L10,13.25 L8,13.25 L8,11.75 L10,11.75 Z M6,11.75 L6,13.25 L4,13.25 L4,11.75 L6,11.75 Z M14,7.75 L14,9.25 L12,9.25 L12,7.75 L14,7.75 Z M6,7.75 L6,9.25 L4,9.25 L4,7.75 L6,7.75 Z M10,7.75 L10,9.25 L8,9.25 L8,7.75 L10,7.75 Z M16,2.75 L2,2.75 C1.86192881,2.75 1.75,2.86192881 1.75,3 L1.75,4.25 L16.25,4.25 L16.25,3 C16.25,2.86192881 16.1380712,2.75 16,2.75 Z" />
          </mask>
          <g mask="url(#applications-mask)">
            <g transform="translate(-3.000000, -2.000000)">
              <rect fill="currentColor" x="0" y="0" width="24" height="24"></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
